import { Collapse, Layout, Widget } from './core/dashboard.node';
import { BehaviorSubject } from 'rxjs';

export class DashboardService {
  public readonly dashboardWidth: BehaviorSubject<number>;
  private _draggingNode!: Layout | Collapse | Widget | null;
  public _hoveredNodeId: string | null | undefined;
  public _selectedNodeId: string | null | undefined;

  get draggingNode(): Layout | Collapse | Widget | null {
    return this._draggingNode;
  }

  get hoveredNodeId(): string | null | undefined {
    return this._hoveredNodeId;
  }

  get selectedNodeId(): string | null | undefined {
    return this._selectedNodeId;
  }

  constructor() {
    this.dashboardWidth = new BehaviorSubject<number>(window.innerWidth);
  }

  public setDraggingNode(node: Layout | Collapse | Widget): void {
    this._draggingNode = node;
  }

  public unsetDraggingNode(): void {
    this._draggingNode = null;
  }

  public setHoveredNode(id: string): void {
    if (this._hoveredNodeId !== id) {
      this._hoveredNodeId = id;
    }
  }

  public unsetHoveredNode(): void {
    this._hoveredNodeId = null;
  }

  public setSelectedNode(id: string): boolean {
    if (this._selectedNodeId !== id) {
      this._selectedNodeId = id;
      return true;
    }

    return false;
  }

  public unsetSelectedNode(): void {
    this._selectedNodeId = null;
  }
}
